import { useState } from "react";

// Destination Landing Section Component
const DestinationLandingSection = ({ destination }) => {
  return (
    <div id={`destino-${destination.slug}`} className="mb-16 last:mb-0 scroll-mt-24">
      {/* Header */}
      <div className="text-center mb-8">
        <h2 className="text-xl sm:text-3xl mb-3" style={{ fontFamily: "'Cinzel', serif" }}>
          Transfer Aeropuerto Málaga → <span className="gradient-text">{destination.name}</span>
        </h2>
        <p className="text-gray-400 max-w-2xl mx-auto">
          {destination.description}
        </p>
      </div>

      {/* CTA Button */}
      <div className="text-center mb-8">
        <a
          href={`https://wa.me/34600221794?text=Hola%20quiero%20precio%20para%20traslado%20M%C3%A1laga%20a%20${encodeURIComponent(destination.name)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#128C7E] text-white font-bold py-3 px-6 rounded-xl transition-all"
        >
          <i className="fab fa-whatsapp text-xl"></i>
          Pedir precio por WhatsApp
        </a>
      </div>

      {/* Info Grid */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <div className="glass rounded-lg p-4 text-center">
          <i className="fas fa-clock text-[#c9a962] text-xl mb-2"></i>
          <p className="text-white font-semibold">{destination.duration}</p>
          <p className="text-xs text-gray-500">Duración</p>
        </div>
        <div className="glass rounded-lg p-4 text-center">
          <i className="fas fa-road text-[#c9a962] text-xl mb-2"></i>
          <p className="text-white font-semibold">{destination.route}</p>
          <p className="text-xs text-gray-500">Ruta</p>
        </div>
        <div className="glass rounded-lg p-4 text-center">
          <i className="fas fa-hourglass-half text-[#c9a962] text-xl mb-2"></i>
          <p className="text-white font-semibold">60 min gratis</p>
          <p className="text-xs text-gray-500">Espera en llegadas</p>
        </div>
        <div className="glass rounded-lg p-4 text-center">
          <i className="fas fa-times-circle text-[#c9a962] text-xl mb-2"></i>
          <p className="text-white font-semibold">Gratis 24h</p>
          <p className="text-xs text-gray-500">Cancelación</p>
        </div>
      </div>

      {/* Zones covered */}
      <div className="text-center mb-6">
        <p className="text-sm text-gray-400">
          <i className="fas fa-map-marker-alt text-[#c9a962] mr-2"></i>
          <strong className="text-white">Zonas:</strong> {destination.zones}
        </p>
      </div>

      {/* FAQs Accordion */}
      <div className="glass rounded-xl p-4">
        {destination.faqs.map((faq, idx) => (
          <div key={idx} className="border-b border-[#2a2a45] py-3 last:border-0">
            <p className="text-sm font-semibold text-white mb-1">
              <i className="fas fa-question-circle text-[#c9a962] mr-2"></i>
              {faq.q}
            </p>
            <p className="text-xs text-gray-400 pl-6">{faq.a}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

// Competitor Conquesting Section - Multiple Destinations
const CompetitorConquestingSection = () => {
  const destinations = [
    {
      slug: "marbella",
      name: "Marbella",
      description: "El destino más exclusivo de la Costa del Sol. Transfer privado desde el aeropuerto de Málaga con conductor profesional. Servicio 24/7.",
      duration: "45-50 min",
      route: "AP-7",
      zones: "Centro Marbella, Golden Mile, Nueva Andalucía, San Pedro, La Fontanilla, Nagüeles",
      faqs: [
        { q: "¿Cuánto tarda el traslado a Marbella?", a: "45-50 min por la AP-7. Ruta directa sin paradas." },
        { q: "¿El conductor espera si mi vuelo se retrasa?", a: "Sí, monitorizamos tu vuelo. 60 min de cortesía en llegadas." },
        { q: "¿Lleváis a hoteles de la Golden Mile?", a: "Sí, cubrimos toda Marbella incluyendo Golden Mile, Puente Romano, Marbella Club, etc." }
      ]
    },
    {
      slug: "puerto-banus",
      name: "Puerto Banús",
      description: "Llega a Puerto Banús con estilo. Conductor en aeropuerto con cartel, vehículo Mercedes premium y precio cerrado. Servicio 24/7.",
      duration: "50-55 min",
      route: "AP-7",
      zones: "Puerto Banús, Nueva Andalucía, Aloha, Las Brisas, La Campana, Los Naranjos",
      faqs: [
        { q: "¿Cuánto tarda el traslado a Puerto Banús?", a: "50-55 min por la AP-7. Sin paradas intermedias." },
        { q: "¿El conductor espera si mi vuelo se retrasa?", a: "Sí, monitorizamos tu vuelo. 60 min de cortesía." },
        { q: "¿Puedo reservar servicio de vuelta al aeropuerto?", a: "Sí, ofrecemos ida y vuelta con descuento." }
      ]
    },
    {
      slug: "benalmadena",
      name: "Benalmádena",
      description: "A solo 20 minutos del aeropuerto. Transfer privado con conductor esperándote en llegadas. Precio cerrado sin sorpresas.",
      duration: "20-25 min",
      route: "A-7",
      zones: "Benalmádena Costa, Arroyo de la Miel, Puerto Marina, Torrequebrada, Bil-Bil",
      faqs: [
        { q: "¿Cuánto tarda el traslado a Benalmádena?", a: "20-25 min por la A-7. Sin paradas." },
        { q: "¿Cubrís la zona de Puerto Marina?", a: "Sí, llevamos a cualquier punto de Benalmádena incluyendo Puerto Marina y Torrequebrada." },
        { q: "¿Cómo sé el precio?", a: "Escríbenos por WhatsApp y te respondemos al instante con precio cerrado." }
      ]
    },
    {
      slug: "estepona",
      name: "Estepona",
      description: "Llega a Estepona sin esperas ni taxis caros. Conductor esperándote en el aeropuerto con cartel, maletas incluidas y precio cerrado. Servicio 24/7.",
      duration: "70-80 min",
      route: "AP-7",
      zones: "Centro Estepona, Puerto Deportivo, Cancelada, El Paraíso, New Golden Mile",
      faqs: [
        { q: "¿Cuánto tarda el traslado a Estepona?", a: "70-80 min por la AP-7. Sin paradas intermedias." },
        { q: "¿El conductor espera si mi vuelo se retrasa?", a: "Sí, monitorizamos tu vuelo. 60 min de cortesía en llegadas." },
        { q: "¿Puedo pagar en efectivo?", a: "Sí, al conductor o por tarjeta/Wise online." }
      ]
    },
    {
      slug: "fuengirola",
      name: "Fuengirola",
      description: "Llega a Fuengirola en 25 min sin esperas. Conductor en aeropuerto con cartel, maletas incluidas y precio cerrado. Servicio 24/7.",
      duration: "25-30 min",
      route: "A-7",
      zones: "Centro Fuengirola, Los Boliches, Torreblanca, Carvajal, Sohail",
      faqs: [
        { q: "¿Cuánto tarda el traslado a Fuengirola?", a: "25-30 min por la A-7. Sin paradas." },
        { q: "¿Esperáis si el vuelo se retrasa?", a: "Sí, 60 min de cortesía. Monitorizamos tu vuelo." },
        { q: "¿Cómo sé el precio?", a: "Escríbenos por WhatsApp y te respondemos al instante." }
      ]
    },
    {
      slug: "torremolinos",
      name: "Torremolinos",
      description: "A 15 min del aeropuerto. Servicio privado con conductor esperándote en llegadas. Precio cerrado, sin sorpresas.",
      duration: "15-20 min",
      route: "MA-21",
      zones: "Centro Torremolinos, La Carihuela, Playamar, Bajondillo, Montemar",
      faqs: [
        { q: "¿Cuánto tarda el traslado a Torremolinos?", a: "15-20 min por la MA-21. Sin paradas." },
        { q: "¿Esperáis si el vuelo se retrasa?", a: "Sí, 60 min gratis en llegadas." },
        { q: "¿Cómo sé el precio?", a: "Escríbenos por WhatsApp con fecha y pasajeros." }
      ]
    },
    {
      slug: "mijas",
      name: "Mijas",
      description: "Llega a Mijas Pueblo o Mijas Costa sin esperas. Transfer privado con conductor en aeropuerto y precio cerrado.",
      duration: "35-45 min",
      route: "A-7 / AP-7",
      zones: "Mijas Pueblo, Mijas Costa, La Cala de Mijas, Calahonda, Las Lagunas",
      faqs: [
        { q: "¿Cuánto tarda el traslado a Mijas?", a: "35-45 min. Mijas Pueblo son 10 min más que Mijas Costa." },
        { q: "¿Esperáis si el vuelo se retrasa?", a: "Sí, 60 min de cortesía en llegadas." },
        { q: "¿Cómo sé el precio?", a: "Escríbenos por WhatsApp y te damos precio cerrado." }
      ]
    },
    {
      slug: "nerja",
      name: "Nerja",
      description: "Llega a Nerja en 45 min sin esperas. Servicio privado 24/7 con conductor en aeropuerto.",
      duration: "45-50 min",
      route: "A-7",
      zones: "Centro Nerja, Burriana, Maro, Torrecilla, Calaceite",
      faqs: [
        { q: "¿Cuánto tarda el traslado a Nerja?", a: "45-50 min por la A-7. Sin paradas." },
        { q: "¿Esperáis si el vuelo se retrasa?", a: "Sí, monitorizamos tu vuelo. 60 min gratis." },
        { q: "¿Cómo sé el precio?", a: "Escríbenos por WhatsApp y te respondemos al instante." }
      ]
    }
  ];

  const benefits = [
    { icon: "fa-euro-sign", title: "Precio cerrado", desc: "Sin recargos por tráfico, maletas o vuelos retrasados." },
    { icon: "fa-clock", title: "Recogida 24/7", desc: "Vuelos de madrugada o noche, siempre hay conductor." },
    { icon: "fa-times-circle", title: "Cancelación gratis", desc: "Hasta 24h antes sin coste." },
    { icon: "fa-car", title: "Flota premium", desc: "Mercedes Clase V, E-Class. Agua y wifi gratis." }
  ];

  const steps = [
    { num: "1", title: "Escríbenos", desc: "Fecha, hora y pasajeros por WhatsApp." },
    { num: "2", title: "Precio al momento", desc: "Presupuesto cerrado en menos de 2 min." },
    { num: "3", title: "Confirmación", desc: "Te enviamos datos del conductor." },
    { num: "4", title: "Recogida", desc: "Te espera con cartel. 60 min de espera gratis." }
  ];

  return (
    <section className="py-16 sm:py-20 px-4 bg-[#0a0a14]" data-testid="competitor-conquesting">
      <div className="max-w-5xl mx-auto">
        {/* Main Header */}
        <div className="text-center mb-12">
          <span className="inline-block bg-[#c9a962]/20 text-[#c9a962] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <i className="fas fa-plane-arrival mr-2"></i>
            TRANSFERS PRIVADOS
          </span>
          <h2 className="text-2xl sm:text-4xl mb-4" style={{ fontFamily: "'Cinzel', serif" }}>
            Transfer Aeropuerto Málaga a <span className="gradient-text">Costa del Sol</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Servicio privado 24/7. Conductor esperándote con cartel. Precio cerrado sin sorpresas.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-12">
          {benefits.map((benefit, idx) => (
            <div key={idx} className="glass rounded-xl p-4 text-center">
              <div className="w-10 h-10 bg-[#c9a962]/20 rounded-full flex items-center justify-center mx-auto mb-2">
                <i className={`fas ${benefit.icon} text-[#c9a962]`}></i>
              </div>
              <h4 className="font-semibold text-white text-sm mb-1">{benefit.title}</h4>
              <p className="text-xs text-gray-400">{benefit.desc}</p>
            </div>
          ))}
        </div>

        {/* How it works */}
        <div className="glass rounded-2xl p-6 mb-12">
          <h3 className="text-lg sm:text-xl text-center mb-6" style={{ fontFamily: "'Cinzel', serif" }}>
            Cómo <span className="gradient-text">funciona</span>
          </h3>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {steps.map((step, idx) => (
              <div key={idx} className="text-center">
                <div className="w-10 h-10 bg-[#c9a962] text-[#1a1a2e] rounded-full flex items-center justify-center mx-auto mb-2 text-lg font-bold">
                  {step.num}
                </div>
                <h4 className="font-semibold text-white text-sm mb-1">{step.title}</h4>
                <p className="text-xs text-gray-400">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Destination Sections */}
        <div className="space-y-12">
          {destinations.map((destination, idx) => (
            <DestinationLandingSection key={idx} destination={destination} />
          ))}
        </div>

        {/* Final CTA */}
        <div className="text-center mt-12 glass rounded-2xl p-8">
          <h3 className="text-xl sm:text-2xl mb-4" style={{ fontFamily: "'Cinzel', serif" }}>
            ¿Otro destino en la <span className="gradient-text">Costa del Sol</span>?
          </h3>
          <p className="text-gray-400 mb-6">
            Benalmádena, Marbella, Puerto Banús, Ronda, Granada, Sevilla... ¡Te llevamos!
          </p>
          <a
            href="https://wa.me/34600221794?text=Hola%20quiero%20precio%20para%20traslado%20desde%20el%20aeropuerto%20de%20M%C3%A1laga"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#c9a962] hover:bg-[#b8944f] text-[#1a1a2e] font-bold py-4 px-8 rounded-xl transition-all text-lg"
          >
            <i className="fab fa-whatsapp text-2xl"></i>
            Pedir precio para otro destino
          </a>
        </div>
      </div>
    </section>
  );
};

export default CompetitorConquestingSection;
